export const PLANNING_FILTER_KEYS = ["mitarbeiterId", "mandatId", "dispositionsstatusId", "mandatsleitungId"];
const VIEWS = new Set(["Tag", "Woche", "Monat", "Jahr"]);
// Production identifiers are Mongo ObjectIds.  The deterministic browser
// contract uses readable, URL-safe fixture identifiers so the complete
// direct-link journey can be exercised without weakening the API validator.
const id = value => typeof value === "string" && (/^[a-f\d]{24}$/i.test(value) || /^(?:emp|mandat)-[a-z\d-]{1,56}$/i.test(value) || /^(?:nfx|prov|opt|fx)$/i.test(value)) ? value : "";

export function planningFilters(search = "") {
  const params = new URLSearchParams(search);
  return {
    mitarbeiterId: id(params.get("mitarbeiterId")),
    mandatId: id(params.get("mandatId")),
    dispositionsstatusId: id(params.get("dispositionsstatusId")),
    mandatsleitungId: id(params.get("mandatsleitungId")),
  };
}

export function planningFilterSearch(search, changes = {}) {
  const params = new URLSearchParams(search);
  for (const key of PLANNING_FILTER_KEYS) {
    const value = key in changes ? changes[key] : id(params.get(key));
    if (value) params.set(key, value); else params.delete(key);
  }
  if (!VIEWS.has(params.get("ansicht"))) params.set("ansicht", "Woche");
  const datum = params.get("datum");
  if (datum && !/^\d{4}-\d{2}-\d{2}$/.test(datum)) params.delete("datum");
  params.delete("von");
  return params.toString();
}

export function planningEntriesPath(period, filters) {
  const params = new URLSearchParams({ von: period.from, bis: period.to, limit: "1000" });
  for (const key of PLANNING_FILTER_KEYS) if (filters[key]) params.set(key, filters[key]);
  return `/planning-entries?${params}`;
}
